import{observer,ComponentView,Preact,h,state,action,Router,Link,Cls,m,Keyframes,Media,isElInViewportForAnimation,divProps,IBaseProps} from "@websites/website_compiler/Client";
import {AEComponentViewProps,AEComponentView} from "../../stores/ui"
import { MediaQuerySizes } from "../../components/Base";
import * as C from "../../components/BaseCss";
import * as Icons from "../../components/Icons";
import * as Sidepanel from "../../components/Sidepanel";
import {Footer, Header, HeaderCenter, HeaderLeft, HeaderRight, PageMargins,SolidBtn,Img,Image,App,FacebookIcon,InstagramIcon} from "../../components/Misc";          
import * as Css from "./homeCss";
import { CompanyData } from "../../misc";
import { text } from "stream/consumers";
declare var Stream;

export module NumberCounter{
    export class Props{
        max:number;
        wait:number;
        step:number;
        afterNumber:string;
    }
    export class View extends AEComponentView<Props>{
        @state num = 0;
        @state isVisible = false;
        ref = Preact.createRef();
        @action setIsVisible(){
            this.isVisible =true;
        }
        @action increment = () =>{
            this.num = this.num + this.props.step;
            if(this.num == this.props.max){
                this.num = this.props.max;
                return;
            }
            setTimeout(()=>{
                this.increment();
            },this.props.wait)
        }
        onScroll = (event)=>{
            // console.log("onScroll",event,this.boardingRef.current.getBoundingClientRect());
            
            if(!this.isVisible  && isElInViewportForAnimation(this.ref.current,150)){
                console.log("ADDING CLASS");
                this.setIsVisible();
                this.increment();
            }

        }
        componentDidMount(){
            window.addEventListener("scroll",this.onScroll)
        }
        componentWillUnmount(){
            window.removeEventListener("scroll",this.onScroll)

        }
        componentDidUpdate(){
            this.onScroll(null);
        }
        render(){
            return <div ref={this.ref} class={Css.numbersNumber}>{this.num + this.props.afterNumber}</div>

        }
    }
}
export module Slider{
    export class Props{

    }

    @observer export class View extends AEComponentView <Props> {
        @state xPos = 90;
        @state animationDone = false;
        container = Preact.createRef();
        @state isVisible = false;
        containerRef = Preact.createRef();


        componentDidMount(){
            window.addEventListener("scroll",this.onScroll)
        }
        componentWillUnmount(){
            window.removeEventListener("scroll",this.onScroll)

        }
        componentDidUpdate(){
            this.onScroll(null);
        }
        @action setAnimationDone(){
            this.animationDone = true;
        }
        @action setIsVisible(){
            this.isVisible =true;
        }
        onScroll = (event)=>{
            // console.log("onScroll",event,this.boardingRef.current.getBoundingClientRect());
            
            if(!this.isVisible  && isElInViewportForAnimation(this.containerRef.current,200)){
                setTimeout(()=>{
                    console.log("ADDING CLASS");
                    this.setIsVisible()
                    setTimeout(()=>{
                        this.setAnimationDone();
                        console.log("TIMEOUT DONE");
                        
                    },900);
                    
                },1000);

            }

        }

        // EVENT LISTENERS
        @action compute(mouseXPos){
            var rect = this.container.current.getBoundingClientRect();
            var x = mouseXPos - rect.left; //x position within the element.
            var pX = (x / rect.width) * 100;
            this.xPos = Math.max( Math.min(90,pX),10 );
        }
        onMouseMove = (e) =>{
            if(!this.animationDone){return false;}
            this.ui.pointer.setMove(e)
            if(this.ui.pointer.isDown){
                this.compute(e.clientX)
            }
        }
        onMouseDown = (e) =>{
            this.ui.pointer.setDown(e);
            this.compute(e.clientX);


        }
        onTouchMove = (event) =>{
            if(!this.animationDone){return false;}
            event.preventDefault();
            this.ui.pointer.setTouchMove(event);
            this.compute(event.targetTouches[0].clientX)
        }
        onTouchStart = (event) =>{
            this.ui.pointer.setTouchStart(event)
        }  

        render(){
            var xPos = this.animationDone ? this.xPos  + "%" : null;
            // console.log("RENDER SLDIER xPos",xPos,Css.slideContainerAnimation,Css.slideContainer);
            
            return (
            <div class={Css.sliderWidthFixer} ref={this.containerRef}>
                <div class={Css.sliderContainer}  onMouseDown={this.onMouseDown} onMouseMove={this.onMouseMove} onTouchMove={this.onTouchMove}  onTouchStart={this.onTouchStart} ref={this.container}>
                    
                        <div class={Css.sliderInner}>
                            <div class={Css.sliderImgContainer}>

                                <svg height="100%" width="100%" >
                                    <defs>
                                        <clipPath id="shape">
                                            <rect x="0" y="0"  style={{ width:xPos}} class={m(Css.sliderClipRect,this.isVisible ? Css.sliderClipRectAnimation : null)} height="100%" />
                                        </clipPath>
                                    </defs>
                                    <Image  lazy={this.ui.lazyLoad} width="100%" height="100%"  href="/assets/home/wall_without_tank.jpg" preserveAspectRatio="xMinYMin slice" class={Css.sliderImg}></Image>
                                    <Image  lazy={this.ui.lazyLoad} width="100%" height="100%"  clip-path="url(#shape)"  href="/assets/home/wall_with_tank.jpg" preserveAspectRatio="xMinYMin slice"  class={Css.sliderImg}></Image>

                                </svg>  
                            </div>
                            <div class={m(Css.sliderSlideContainer,this.isVisible ? Css.sliderSlideContainerAnimation : null)} style={{left:xPos}} >
                                <div class={Css.sliderBar}></div>
                                <button class={Css.sliderHandle} title="Slide Me!">
                                    <Icons.Double_Arrow class={Css.sliderHandleIcon}></Icons.Double_Arrow>
                                </button>
                            </div>
                        </div>
                    </div>

          
                </div>

            )
        }
        
    }
    

}

export module Steps{
    export class Props{

    }

    @observer export class View extends AEComponentView <Props> {
        containerRef = Preact.createRef();
        @state isVisible = false;
        
        isElInViewportForAnimation(el,dist) {
            // console.log("bounding",el);

            var bounding = el.getBoundingClientRect();
            
            var height = window.innerHeight || document.documentElement.clientHeight;
            var dif = height - bounding.top;
            if (dif > dist) {
                return true;
            }
        }
        componentDidMount(){
            window.addEventListener("scroll",this.onScroll)
        }
        componentWillUnmount(){
            window.removeEventListener("scroll",this.onScroll)

        }
        componentDidUpdate(){
            this.onScroll(null);
        }
        onScroll = (event)=>{
            // console.log("onScroll",event,this.boardingRef.current.getBoundingClientRect());
            
            if(!this.isVisible  && this.isElInViewportForAnimation(this.containerRef.current,200)){
                console.log("ADDING CLASS");
                this.isVisible =true;
            }

        }
        render(){
            var cls = this.isVisible ? m(Css.stepsImgTile,Css.stepsImgTileAnimation) : Css.stepsImgTile
            return (
                <div class={Css.stepsContainerBg} ref={this.containerRef}>
                <PageMargins innerCls={Css.stepsContainer}>
                <Icons.LionFish_Outline class={Css.stepsBgIcon}></Icons.LionFish_Outline>

                    <div class={Css.stepsLeft}>
                        {/* <h5 class={Css.title}>We handle everything for you!</h5> */}
                        <h5 class={Css.stepsTitle}>All your water feature needs!</h5>
                        {/* <h5 class={Css.title}>We got you from start to finish!</h5> */}

                            <p>No matter what step you are at with your project - designing, building, moving, or maintaining - Aquatic Edge will work with you every step of the way to bring your imagination to life.</p>

                        <Icons.Timeline class={Css.stepsIcon}></Icons.Timeline>
                    </div>
                    <div class={Css.stepsRight}>
                        <div class={Css.stepsImgTileContainer}>
                            <div class={Css.stepsImgTileColumn} style={{marginTop:"0px"}}>
                                <Img alt="Blueprints" lazy={this.ui.lazyLoad} class={cls} src="/assets/home/step_1.jpg" style={{animationDelay:"0s"}}></Img>
                                <Img alt="Fish Tank Moving" lazy={this.ui.lazyLoad}  class={cls} src="/assets/home/step_3.jpg" style={{animationDelay:"1s"}}></Img>
                            </div>
                            <div class={Css.stepsImgTileColumn}  style={{marginTop:"50px"}} >
                                <Img alt="Fish Tank Assembly" lazy={this.ui.lazyLoad} class={cls} src="/assets/home/step_2.jpg" style={{animationDelay:"0.3s"}}></Img>
                                <Img alt="Fish Tank Filling" lazy={this.ui.lazyLoad} class={cls} src="/assets/home/step_4.jpg"style={{animationDelay:"1.3s"}} ></Img>
                            </div>
                            <div class={Css.stepsImgTileColumn}  style={{marginTop:"100px"}}>
                                <Img alt="Fish Tank Maintenace" lazy={this.ui.lazyLoad} class={cls} src="/assets/home/step_6.jpg"style={{animationDelay:"0.6s"}} ></Img>
                                <Img alt="Fish Tank Completed" lazy={this.ui.lazyLoad} class={cls} src="/assets/home/step_5.jpg"style={{animationDelay:"1.9s"}}></Img>
                            </div>
                        </div>

                    </div>
                </PageMargins>
            </div>

            )
        }
        
    }
    

}
export module Customers{
    export class Props{

    }

    @observer
    export class View extends AEComponentView <Props> {

        

        render(){
            return (
                <div class={Css.customersContainerBG}>
                <PageMargins innerCls={Css.customersContainer}>
                    <Icons.ThumbsUp class={Css.thumbsUp}></Icons.ThumbsUp>
                    <h6 class={Css.stepsTitle}>Our Customers</h6>
                    <p class={Css.description}>We are proud of our long term relationships with our clients. No tank too big and no tank too small.  Here are just a few of our well known customers.</p>
                    <div class={Css.customersIconsContainer}>
                        <Img alt="Rainforest Cafe" lazy={this.ui.lazyLoad} src="/assets/customers/rainforestcafe.png" class={m(Css.customersIcon,Css.customersIconLarge)}></Img>
                        <div class={C.columnCenter}>
                            <Img alt="Mandarin (Subcontracted)" lazy={this.ui.lazyLoad} src="/assets/customers/mandarin.png" class={m(Css.customersIcon,Css.customersIconXXLarge)}></Img>
                            <span class={Css.subcontracted}>( Subcontracted )</span>
                        </div>

                        <Img alt="Dawson Dental" lazy={this.ui.lazyLoad} src="/assets/customers/dawson.png" class={m(Css.customersIcon,Css.customersIconSmall)}></Img>
                        <Img alt="Grand Empire Banquethall" lazy={this.ui.lazyLoad} src="/assets/customers/grandempirebanquethall.png" class={m(Css.customersIcon,Css.customersIconLarge)}></Img>
                        <Img alt="UCCC" lazy={this.ui.lazyLoad} src="/assets/customers/uccc.png" class={m(Css.customersIcon,Css.customersIconXLarge)}></Img>
                        <Img alt="Canalfa" lazy={this.ui.lazyLoad} src="/assets/customers/canalfa.png" class={m(Css.customersIcon,Css.customersIconLarge)}></Img>


                    </div>
                </PageMargins>
            </div>

            )
        }
        
    }

}

interface AspectRatioQuery {width:number,height:number,query?:string,centerX?:boolean,centeryY?:boolean} // ratio width / height
export interface AspectRatioProps{
    queries:AspectRatioQuery[],
    class?:string;
    log?:boolean;
}
@observer export class AspectRatio extends AEComponentView<AspectRatioProps>{
    ref = Preact.createRef();
    resizeListener :any;
    @state width = "0px";
    @state height = "0px";
    @state top = "0px";
    @state left = "0px";
    componentDidMount(){
        window.addEventListener('resize', this.onResize);
        setTimeout(()=>{this.onResize(null)},100)
        setTimeout(()=>{this.onResize(null)},1000) // double check it resize correctly ?????
        this.onResize(null);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize = (event) => {
        let foundQuery: AspectRatioQuery;
        for (let i = 0; i < this.props.queries.length; i++) {
            const query = this.props.queries[i];
            if(query.query){
                const mediaQueryList = window.matchMedia(query.query);
                if(mediaQueryList.matches) {
                    foundQuery = query;
                }
            }else if(!foundQuery){
                foundQuery = query;
            }
        }
        if(foundQuery){
            console.log("found")
            const rect = this.ref.current.parentNode.getBoundingClientRect();
            const queryAspectRatio = foundQuery.width / foundQuery.height;
            const curAspectRatio = rect.width / rect.height;


            let width = 0;
            let height = 0;
            if(queryAspectRatio > curAspectRatio){
                height = rect.height 
                width =  Math.trunc(rect.height * queryAspectRatio)
            }else{
                width = rect.width 
                height =  Math.trunc(rect.width / queryAspectRatio) ;
            }
            
            this.width = width + "px";
            this.height = height + "px";

            if(foundQuery.centeryY){
                this.top = ( ((height - rect.height) / 2)) * -1 + "px";
            }else{
                this.top = "0px";
            }
            if(foundQuery.centerX){
                this.left = ( ((width - rect.width) / 2)) * -1 + "px";
            
            }else{
                this.left = "0px";
            }
            
            if(this.props.log){
                console.log("rect",queryAspectRatio,curAspectRatio,rect.width ,rect.height)
            }
        }
    }

    render(){
        console.log("RESIZE RENDER")
        return <div ref={this.ref} style={{width:this.width ,height:this.height,top:this.top,left:this.left}}  class={this.props.class}>
            {this.props.children}
        </div>
    }
}

export class CloudflareVideoProps{
    title:string;
}
@observer export class CloudflareVideo extends AEComponentView<CloudflareVideoProps>{
    iframeRef = Preact.createRef();
    isUsingMobile = null;

    componentDidMount(): void {
        const iframeEl = this.iframeRef.current;
        if(iframeEl){
            const player = Stream(iframeEl);
            player.addEventListener('play', () => {
                console.log('play!')
            })
    
            player.play().catch(() => {
                console.log('playback failed, muting to try again')
                player.muted = true
                player.play()
            })
    
            player.addEventListener('playing', () => {
                console.log('playingggg!')
                // var imgEl = document.getElementById("heroImg");
                // imgEl.style.opacity = "0";
                // this.imgVisible = false;
                iframeEl.style.display="block"
            })
        }
        window.addEventListener("resize",this.resize);
        iframeEl && this.resize(null)
    }
    resize(e){

    }
    render(props: CloudflareVideoProps & AEComponentViewProps & IBaseProps, state: any) {
        return <iframe title= {this.props.title}  ref={this.iframeRef} src={""} allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="false"></iframe>

    }
}


export class Props{
}
export class Page extends AEComponentView<Props>{

    heroIframeRef = Preact.createRef();
    socialIframeRef = Preact.createRef();

    imgVisible = true;
    iframeSrc = "";
    lazyLoad = true;
    isUsingMobile = null;
    socialVisible = false;
    playingSocial = false;
    @action videoPlaying = () =>{
        console.log('playingggggg');
        // var imgEl = document.getElementById("heroImg");
        // imgEl.style.display= "none";
        // this.imgVisible = false;

    }
    componentDidMount(){
        console.log("mounted HOME");

        



        // lazy
        this.ui.lazyLoadImages();
        window.addEventListener("load",()=>{
            setTimeout(()=>{
                this.playSocialVideo();
            },2000)
            window.addEventListener("resize",this.resize);
            window.addEventListener("scroll",this.onScroll);
            this.resize(null);
            this.playHeroVideo();
            this.onScroll(null);

        });


        


    }
    componentDidUpdate(){

    }
    resize = (event) => {
        console.log("resizing")
        const heroEl = this.heroIframeRef.current;
        if(heroEl){
            console.log("window.innerWidt",window.innerWidth);
            
            if(window.innerWidth > 550 && (this.isUsingMobile === true || this.isUsingMobile === null)){
                heroEl.style.display="none";
                heroEl.src = "https://iframe.videodelivery.net/41cfb5258097c5f221fc1f8dbc40b446?muted=true&loop=true&autoplay=true&controls=false";
                this.isUsingMobile = false;
                console.log("SETTING DESK",this.isUsingMobile);
                
            }else if(window.innerWidth < 551 && (this.isUsingMobile === false  || this.isUsingMobile === null)){
                heroEl.style.display="none";
                heroEl.src = "https://iframe.videodelivery.net/a2210172a5629627897510abdc0d3b57?muted=true&loop=true&autoplay=true&controls=false";
                this.isUsingMobile = true;
                console.log("SETTING MOBILE",this.isUsingMobile);
            }
        }
        console.log("this.isUsingMobile",this.isUsingMobile)

    }
    componentWillUnmount(){
        // window.removeEventListener("resize",this.resize)

    }
    playHeroVideo(){
        // CF
        const iframeEl = this.heroIframeRef.current;
        if(iframeEl){
            const player = Stream(iframeEl);
            player.addEventListener('play', () => {
                console.log('play!')
            })
    
            player.play().catch(() => {
                console.log('playback failed, muting to try again')
                player.muted = true
                player.play()
            })
    
            player.addEventListener('playing', () => {
                console.log('playingggg!')
                // var imgEl = document.getElementById("heroImg");
                // imgEl.style.opacity = "0";
                // this.imgVisible = false;
                iframeEl.style.display="block"
            })
        }
    }
    playSocialVideo(){
        console.log("playSocialVideo")
        const socialFrameEl = this.socialIframeRef.current;
        if(socialFrameEl && !this.playingSocial){
            const src = "https://iframe.videodelivery.net/61abeceb4878838ef5739629ad48dd8d?muted=true&loop=true&autoplay=true&controls=false";
            socialFrameEl.src = src;
            this.playingSocial = true;
            const player = Stream(socialFrameEl);
            player.addEventListener('play', () => {
                console.log('play!')
            })
    
            player.play().catch(() => {
                console.log('playback failed, muting to try again')
                player.muted = true
                player.play()
            })
    
            player.addEventListener('playing', () => {
                console.log('playingggg sociall!')
                // var imgEl = document.getElementById("heroImg");
                // imgEl.style.opacity = "0";
                // this.imgVisible = false;
                socialFrameEl.style.display="block"
            })
        }
    }
    onScroll = (event)=>{
        // console.log("onScroll",event,this.boardingRef.current.getBoundingClientRect());
        
        if(!this.socialVisible  && !this.playingSocial && isElInViewportForAnimation(this.socialIframeRef.current,200)){
            console.log("social in view")
            this.playSocialVideo();
        }

    }
    render(){
        console.log("HOME RENDER")
        const phabletMin = `( min-width: ${MediaQuerySizes.phabletMin}px )`;
        return (

            <App ui={this.ui} description={"Your custom aquarium and pond specialist. Serving downtown Toronto and the GTA for more than 25 years."}>
                
                {/* <div dangerouslySetInnerHTML={{__html: "<span>foobar</span>"}}></div> */}
                {/* <script dangerouslySetInnerHTML={{__html: "alert(1);"}}></script> */}
                
                <div class={Css.fixedBgContainer}>
                    <PageMargins fillToSideBar>
                    <picture alt="" >
                        <source  srcset="/assets/home/home_page_undeerwater.png" media={`( min-width: ${MediaQuerySizes.smallDesktopMin}px )`}/>
                        <img class={Css.fixedBgImg}   src="/assets/home/home_page_undeerwater_tablet.png"  alt="Background picture of aquarium with lion fish and coral"/>
                    </picture>
                        {/* <img 
                            srcset="/assets/home/home_page_undeerwater.png 1920w, /assets/home/home_page_undeerwater_tablet.png 1080w" 
                            class={Css.fixedBgImg} 
                            src="/assets/home/home_page_undeerwater_tablet.png" 
                            sizes={`( min-width: ${MediaQuerySizes.smallDesktopMin}px ) 1080px`}>
                        </img>    */}
                    </PageMargins> 
                </div>
                <PageMargins fillToSideBar>
                    <div class={m(Css.heroFullContainer,C.whiteIcon)}>
                        <div class={Css.heroBgContainer}>
                            <AspectRatio queries={[{width:584,height:800 }, {width:1920,height:1080,query:phabletMin}]} class={Css.heroAspectContainer}>
                                <iframe  title="Background video of aquariums"  ref={this.heroIframeRef} src={""} id={Css.heroIframe}  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="false"></iframe>
                                <picture alt="" id="heroImg" >
                                    <source width="960" height="540" srcset="/assets/home/hero_desktop_first_frame.jpg" media={phabletMin}/>
                                    <img class={Css.heroAspectSizer} width="584" height="800" src="/assets/home/hero_mobile_first_frame.jpg" alt="Background picture of aquarium with lion fish and coral"/>
                                </picture>
                            </AspectRatio>
                        </div>
                        <div class={Css.heroFgContainer}>


                            <div style={{position:"relative"}} class={C.columnCenter}>
                            <div class={Css.heroSlashContainer}>
                                        <Icons.Fish_1 class={Css.heroFishIcon}></Icons.Fish_1>
                                        {/* <Icons.Seaweed_1 class={Css.heroH1Icon}></Icons.Seaweed_1> */}
                                    </div>
                                <h1 class={m(Css.heroH1)}> <span class={Css.heroH1Span}>Living Water</span><span class={Css.heroH1SpanSpace}>&nbsp;</span><span class={Css.heroH1Span}>Feature Specialists</span></h1>
                                <h2 class={Css.heroH2} >Transforming spaces with the serenity of water</h2>
                                {/* <h1 class={m(C.h1XLarge,Css.heroH1)}>Living Water Feature Specialists </h1>
                                <div class={Css.heroH2Container}>
                                    <h3 > our one-stop shop for all your water feature needs! We proudly serve downtown Toronto and the GTA, transforming spaces with the serenity of water.</h3> 
                                </div>
                                <h2 class={Css.heroH2}>Serving Downtown Toronto and the GTA</h2>

                                <h1 style={{textAlign:"center"}}class={m(C.h1XLarge, Css.heroH1)}>Living Water Feature Specialists</h1>
                                <div class={Css.heroH2Container}>
                                    <h2 style={{maxWidth:"800px",textAlign:"center"}}  class={Css.heroSubheading}>Transform Your Space with the Serenity of Water</h2>
                                    <p style={{maxWidth:"800px",textAlign:"center"}} class={Css.heroDescription}>Your premier water feature experts serving Downtown Toronto and the Greater Toronto Area. From design to maintenance, we bring your aquatic visions to life.</p>
                                </div> */}

                                <div class={m(C.rowCenterCenter,C.childM0M10,Css.ctaContainer)}>
                                    <SolidBtn outline white class={Css.ctaBtn}  href={this.ui.routes.contact.url()}>Contact</SolidBtn>
                                    <SolidBtn white class={Css.ctaBtn} href={this.ui.routes.gallery.url()}>Gallery</SolidBtn>
                                </div>
                            </div>                       
                        </div>
                    </div>
                </PageMargins>
                <div class={m(Css.midSectionContainer)}>
                    
                    {/* <div class={Css.underwaterBgContainer}>
                        <PageMargins fillToSideBar>
                                <img class={Css.underwaterBgImg} src="/assets/home/home_page_undeerwater.png"></img>   

                        </PageMargins>
                         
                    </div>
                     */}
                    <div class={Css.displayContainerBg}>
                        <PageMargins  innerCls={Css.displayContainer}>
                                <div class={m(Css.grassContainer,C.whiteIcon)}>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                    <Icons.Grass_Line class={Css.grassIcon}></Icons.Grass_Line>
                                </div>
                                <div class={m(Css.displayBoxsContainer)}>
                                    <div class={m(Css.displayBox,Css.displayBoxTop2)}>
                                        <Icons.Pond_2 class={Css.displayBoxIcon}></Icons.Pond_2>
                                        <h3 class={Css.displayBoxTitle}>Ponds</h3>
                                        <p>Cultivate a healthy backyard ecosystem when building, designing and maintaining a fish or plant pond.</p>
                                    </div>
                                    <div class={m(Css.displayBox,Css.displayBoxTop2)}>
                                        <Icons.WaterWall class={Css.displayBoxIcon}></Icons.WaterWall>
                                        <h3 class={Css.displayBoxTitle}>Water Walls</h3>
                                        <p>Instantly transform the landscape and architecture with the melody of a running water feature</p>
                                    </div>
                                    <div class={Css.displayBox}>
                                        <Icons.Tank class={Css.displayBoxIcon}></Icons.Tank>
                                        <h3 class={Css.displayBoxTitle}>Aquariums</h3>
                                        <p>We handle all types of aquariums, including live coral reef, salt water, fresh water, structural or large commercial aquariums.</p>
                                    </div>
                                    <div class={Css.displayBox}>
                                        <Icons.Maintenance class={Css.displayBoxIcon}></Icons.Maintenance>
                                        <h3 class={Css.displayBoxTitle}>Maintenance</h3>
                                        <p>Have an existing water feature that needs maintenace or upkeep? We are here to help.</p>
                                    </div>
                                </div>
                                <div class={Css.displayOtherContainer}>
        
                                    <div class={Css.displayOtherContainerSection}>
                                        <div class={Css.displayDetailContaienr}>
                                            <div class={Css.displayCheckMarkContainer}>
                                                <Icons.Checkmark class={Css.displayCheckMark}></Icons.Checkmark>
                                            </div>
                                            <div>Tank Relocation</div>
                                        </div>
                                        <div class={Css.displayDetailContaienr}>
                                            <div class={Css.displayCheckMarkContainer}>
                                                <Icons.Checkmark class={Css.displayCheckMark}></Icons.Checkmark>
                                            </div>
                                            <div>Certified Aquarium Diver</div>
                                        </div>  
                                    </div>
                                    <div class={Css.displayOtherContainerSection}>
                                        <div class={Css.displayDetailContaienr}>
                                            <div class={Css.displayCheckMarkContainer}>
                                                <Icons.Checkmark class={Css.displayCheckMark}></Icons.Checkmark>
                                            </div>
                                            <div>Fully Automated Systems</div>
                                        </div>  
                                        <div class={Css.displayDetailContaienr}>
                                            <div class={Css.displayCheckMarkContainer}>
                                                <Icons.Checkmark class={Css.displayCheckMark}></Icons.Checkmark>
                                            </div>
                                            <div>Livestock and Dry Goods</div>
                                        </div>
                                    </div>
                                </div>
                        </PageMargins>
                    </div>
                    <div class={Css.numbersContainer}>
                        <PageMargins>
                            <h4 class={Css.largeTitleThin}>Let us bring nature to you!</h4>
                            {/* <h5 class={Css.largeTitleThin}>We handle everything for you!</h5> */}
                            <p class={Css.numbersMainDesc}>When you choose Aquatic Edge, you benefit from the technical expertise of fully qualified, licensed and insured water feature specialists with years of working in the living water feature industry. </p>
                            <div class={Css.numbersRow}>
                                <div class={Css.numbersBox}>

                                    <NumberCounter.View max={25} wait={50} step={1} afterNumber={"+"}></NumberCounter.View>

                                    <div class={Css.numbersTitle}>Years</div>
                                    <div class={Css.numbersSubTitle}>Experience</div>
                                    <p class={Css.numbersDesc}>{"The fish and aquarium business has been in the family even before Aquatic Edge's 25 years of business."}</p>
                                </div>
                                <Icons.Plant_1 class={Css.numbersPlant}></Icons.Plant_1>


                                <div class={Css.numbersBox}>
                                    <NumberCounter.View max={500} wait={10} step={5} afterNumber={"+"}></NumberCounter.View>
                                    <div class={Css.numbersTitle}>Tanks</div>
                                    <div class={Css.numbersSubTitle}>Serviced</div>
                                    <p class={Css.numbersDesc}>With 500+ tanks serviced we have seen it all! Feel confident in having high quality reliable systems that won't break down. </p>

                                </div>
                                <Icons.Plant_1 class={m(Css.numbersPlant,Css.numbersPlant2)}></Icons.Plant_1>
                                <div class={Css.numbersBox}>
                                    <NumberCounter.View max={24} wait={50} step={1} afterNumber={"/7"}></NumberCounter.View>

                                    <div class={Css.numbersTitle}>Emergency</div>
                                    <div class={Css.numbersSubTitle}>Service</div>
                                    <p class={Css.numbersDesc}>{"Water feature emergencies can be stressful. With our 24/7 emergency service you can just relax and enjoy your beautifully crafted water feature"}</p>

                                </div>
                            </div>
                        </PageMargins>
                    </div>
                </div>

                <div class={Css.transformContainerBG}>
                    <PageMargins  innerCls={Css.transformContainer}>
                        <Slider.View ui={this.ui}></Slider.View>
                        
                        <div class={Css.transformRight}>
                            <Icons.Floorplan class={Css.transformRightIcon}></Icons.Floorplan>
                            <h5 class={Css.transformRightTitle}>Transform Your Space</h5>
                            <p>{"Fish tanks are a great way to provide natural sounds and visuals that create a tranquil atmosphere for your living or office space."}</p>
                        </div>
                    </PageMargins>
                </div>

                <Steps.View ui={this.ui}></Steps.View>
                
                <div class={Css.socialContainerBg}>
                    <PageMargins fillToSideBar containerStyles={{height:"100%"}}>
                        <AspectRatio log queries={[{width:720,height:1280,centerX:true,centeryY:true}]} class={Css.heroAspectContainer}>
                                <iframe  title="Background video of aquariums"  ref={this.socialIframeRef} src={""} id={Css.heroIframe}  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="false"></iframe>
                                {/* <picture alt="" id="heroImg" >
                                    <source width="960" height="540" srcset="/assets/home/hero_desktop_first_frame.jpg" media={phabletMin}/>
                                    <img class={Css.heroAspectSizer} width="584" height="800" src="/assets/home/hero_mobile_first_frame.jpg" alt="Background picture of aquarium with lion fish and coral"/>
                                </picture> */}
                        </AspectRatio>
                        <div class={Css.socialContainerBgOverlay}>
                                
                                

                        </div>
                        <div class={Css.socialCotnent}>
                            <h3 class={Css.socialHeader}>Come say hi on social media!</h3>
                            <div class={Css.socialBtnContainer}>
                                <SolidBtn  target="_blank" regLink white class={Css.socialBtn} href={CompanyData.facebookUrl}>
                                    <FacebookIcon class= {Css.socialBtnIcon} color= {C.primaryDarkest}></FacebookIcon>
                                    <span style={{width:"100%"}}>Facebook</span>
                                </SolidBtn>

                                <SolidBtn   target="_blank" regLink white class={Css.socialBtn} href={CompanyData.instagramUrl}>

                                    <InstagramIcon  class= {Css.socialBtnIcon} color= {C.primaryDarkest}></InstagramIcon>

                                    <span style={{width:"100%"}}>Instagram</span>
                                </SolidBtn>
                            </div>
                        </div>
                    </PageMargins> 


                </div>
                <Customers.View ui={this.ui}></Customers.View>

                <Footer.View></Footer.View>
                <Header noSpacer transparent ui={this.ui}>
                    <HeaderLeft ui={this.ui}></HeaderLeft>
                    <HeaderCenter></HeaderCenter>
                    <HeaderRight></HeaderRight>
                </Header>
                <Sidepanel.View transparentMode ui={this.ui}></Sidepanel.View>
            </App>

        )
    }
    
}
